const BACK_OFFICE_MASTER_DATA_URL = "/master-data/general-configuration";

export default [
  {
    level: 3,
    key: "title.accountingPeriod",
    link: `${BACK_OFFICE_MASTER_DATA_URL}/accounting-period`,
  },
  {
    level: 3,
    key: "title.inventoryPeriod",
    link: `${BACK_OFFICE_MASTER_DATA_URL}/inventory-period`,
  },
  {
    level: 3,
    key: "title.paymentTerm",
    link: `${BACK_OFFICE_MASTER_DATA_URL}/payment-term`,
  },
  {
    level: 3,
    key: "title.unitOfMeasurement",
    link: `${BACK_OFFICE_MASTER_DATA_URL}/unit-of-measurement`,
  },
  {
    level: 3,
    key: "title.warehouseLocation",
    link: `${BACK_OFFICE_MASTER_DATA_URL}/warehouse-location`,
  },
  {
    level: 3,
    key: "title.bankAccount",
    link: `${BACK_OFFICE_MASTER_DATA_URL}/bank-account`,
  },
  {
    level: 3,
    key: "title.depositAccount",
    link: `${BACK_OFFICE_MASTER_DATA_URL}/deposit-account`,
  },
  {
    level: 3,
    key: "title.numberSeries",
    link: `${BACK_OFFICE_MASTER_DATA_URL}/number-series`,
  },
  {
    level: 3,
    key: "title.purchaseRequisitionBatch",
    link: `${BACK_OFFICE_MASTER_DATA_URL}/purchase-requisition-batch`,
  }, {
    level: 3,
    key: "title.storeRequisitionBatch",
    link: `${BACK_OFFICE_MASTER_DATA_URL}/store-requisition-batch`,
  },
  {
    level: 3,
    key: "title.generalJournalBatch",
    link: `${BACK_OFFICE_MASTER_DATA_URL}/general-journal-batch`,
  },
  {
    level: 3,
    key: "title.itemJournalBatch",
    link: `${BACK_OFFICE_MASTER_DATA_URL}/item-journal-batch`,
  },
  {
    level: 3,
    key: "title.interDepartmentTransferBatch",
    link: `${BACK_OFFICE_MASTER_DATA_URL}/inter-department-transfer-batch`,
  },
  {
    level: 3,
    key: "title.reportSetting",
    link: `${BACK_OFFICE_MASTER_DATA_URL}/report-setting`,
  },
  {
    level: 3,
    key: "title.printoutLayout",
    link: `${BACK_OFFICE_MASTER_DATA_URL}/printout-layout`,
  },
];
